import React, { Component } from 'react';
import firebase from '../../../config/fbConfig';
import Creatable from 'react-select/creatable'
import { tagFunctions } from '../Tags'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { editRestaurant, editCreateRestaurant, pendingEditRestaurant } from '../../../store/actions/restaurantActions'

class AdminEditRestaurant extends Component {

  constructor(props) {
    super(props);
    this.state = {
    name: '',
    url: '',
    phoneNumber: '',
    orderUrl: '',
    menuUrl: '',
    address: '',
    hours: '',
    content: '',
    tags: '',
    authorId: '',
    createdAt: '',
    editorId: '',
    editedAt: '',
    restaurantId: '',
    
    sunAM: 'AM',
    sunPM: 'PM',
    sundayAM: '',
    sundayPM: '',
    
    monAM: 'AM',
    monPM: 'PM',
    mondayAM: '',
    mondayPM: '',

    tueAM: 'AM',
    tuePM: 'PM',
    tuesdayAM: '',
    tuesdayPM: '',

    wedAM: 'AM',
    wedPM: 'PM',
    wednesdayAM: '',
    wednesdayPM: '',

    thuAM: 'AM',
    thuPM: 'PM',
    thursdayAM: '',
    thursdayPM: '',

    friAM: 'AM',
    friPM: 'PM',
    fridayAM: '',
    fridayPM: '',

    satAM: 'AM',
    satPM: 'PM',
    saturdayAM: '',
    saturdayPM: '',

    fromPending: false
    };
  }

  componentDidMount() {
    const ref = firebase.firestore().collection('pending').doc(this.props.match.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        const restaurant = doc.data();
        this.setState({
          name: restaurant.name,
          url: restaurant.url,
          phoneNumber: restaurant.phoneNumber,
          orderUrl: restaurant.orderUrl,
          menuUrl: restaurant.menuUrl,
          address: restaurant.address,
          content: restaurant.content,
          tags: restaurant.tags,
          hours: restaurant.hours,
          createdAt: restaurant.createdAt,
          authorId: restaurant.authorId,
          editedAt: restaurant.editedAt,
          editorId: restaurant.editorId,
          restaurantId: restaurant.restaurantId,

          sunAM: restaurant.sunAM,
          sunPM: restaurant.sunPM,
          sundayAM: restaurant.sundayAM,
          sundayPM: restaurant.sundayPM,
          
          monAM: restaurant.monAM,
          monPM: restaurant.monPM,
          mondayAM: restaurant.mondayAM,
          mondayPM: restaurant.mondayPM,

          tueAM: restaurant.tueAM,
          tuePM: restaurant.tuePM,
          tuesdayAM: restaurant.tuesdayAM,
          tuesdayPM: restaurant.tuesdayPM,

          wedAM: restaurant.wedAM,
          wedPM: restaurant.wedPM,
          wednesdayAM: restaurant.wednesdayAM,
          wednesdayPM: restaurant.wednesdayPM,

          thuAM: restaurant.thuAM,
          thuPM: restaurant.thuPM,
          thursdayAM: restaurant.thursdayAM,
          thursdayPM: restaurant.thursdayPM,

          friAM: restaurant.friAM,
          friPM: restaurant.friPM,
          fridayAM: restaurant.fridayAM,
          fridayPM: restaurant.fridayPM,

          satAM: restaurant.satAM,
          satPM: restaurant.satPM,
          saturdayAM: restaurant.saturdayAM,
          saturdayPM: restaurant.saturdayPM,

          fromPending: true
        });
        console.log('test');
        console.log(this.props.match.params.id);
        console.log(this.state.restaurantId);
        console.log(this.props)
      } else {
        //look for it in pendingCreate
        const ref2 = firebase.firestore().collection('pendingCreate').doc(this.props.match.params.id);
        ref2.get().then((doc) => {
      if (doc.exists) {
        const restaurant = doc.data();
        this.setState({
          name: restaurant.name,
          url: restaurant.url,
          phoneNumber: restaurant.phoneNumber,
          orderUrl: restaurant.orderUrl,
          menuUrl: restaurant.menuUrl,
          address: restaurant.address,
          content: restaurant.content,
          tags: restaurant.tags,
          hours: restaurant.hours,
          createdAt: restaurant.createdAt,
          authorId: restaurant.authorId,
          editedAt: restaurant.editedAt,
          editorId: restaurant.editorId,
          restaurantId: this.props.match.params.id,

          sunAM: restaurant.sunAM,
          sunPM: restaurant.sunPM,
          sundayAM: restaurant.sundayAM,
          sundayPM: restaurant.sundayPM,
          
          monAM: restaurant.monAM,
          monPM: restaurant.monPM,
          mondayAM: restaurant.mondayAM,
          mondayPM: restaurant.mondayPM,

          tueAM: restaurant.tueAM,
          tuePM: restaurant.tuePM,
          tuesdayAM: restaurant.tuesdayAM,
          tuesdayPM: restaurant.tuesdayPM,

          wedAM: restaurant.wedAM,
          wedPM: restaurant.wedPM,
          wednesdayAM: restaurant.wednesdayAM,
          wednesdayPM: restaurant.wednesdayPM,

          thuAM: restaurant.thuAM,
          thuPM: restaurant.thuPM,
          thursdayAM: restaurant.thursdayAM,
          thursdayPM: restaurant.thursdayPM,

          friAM: restaurant.friAM,
          friPM: restaurant.friPM,
          fridayAM: restaurant.fridayAM,
          fridayPM: restaurant.fridayPM,

          satAM: restaurant.satAM,
          satPM: restaurant.satPM,
          saturdayAM: restaurant.saturdayAM,
          saturdayPM: restaurant.saturdayPM,

          fromPending: false

        });
        console.log('test');
        console.log(this.props.match.params.id);
        console.log(this.state.restaurantId);
        console.log(this.props)
      } else {
        console.log("No such document!");
      }
    });
      }
    });
  }

  handleSelect = (selection) =>{
    var tags = [];
    if(selection){
    tags = selection.map(mapTags);
    this.setState({ tags: tags });  
    }
    else{
      this.setState({ tags: '' });  
    }
    console.log(selection)
  }  

  
  onFocus = (event) => {
   if(event.target.autocomplete){
     event.target.autocomplete = "off";
     console.log(event.target)
   }
  }

  onBlur = (e) => {
    if (!e.target.value.includes(':')){
      var x = e.target.value.replace(/\D/g, '');
      var y = '';
      if (x.length === 1){
        y = (x[0]+':00')
      }
      else if (x.length === 2){
        if (x[0] === 0){
          y = (x[1]+':00')  
        }
        else if (x[0] === 1 && (x[1] === 0 || x[1] === 1 || x[1] === 2)){
          y = (x[0]+x[1]+':00') 
        }
        else { 
          y = (x[0]+':'+x[1]+'0')
        }
      }
      else if (x.length === 3){
        if (x[0] === 0){
          y = (x[1]+':'+x[2]+'0')  
        }
        else if (x[0] === 1 && (x[1] === 0 || x[1] === 1 || x[1] === 2)){
          y = (x[0]+x[1]+':'+x[2]+'0') 
        }
        else {
          y = (x[0]+':'+x[1]+x[2])
        }
      }
      else{
        if (x[0] === 0){
          y = (x[1]+':'+x[2]+x[3])
        }
        else{
          y = (x[0]+x[1]+':'+x[2]+x[3])
        }
      }
    if(y!=='NaN:undefinedundefined'){
    e.target.value = y;
    this.setState({
      [e.target.id]: y
    });  
    }
  }
  }

  handleChange = (e) => {
    if (e.target.id==='phoneNumber'){
      var z = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      console.log(z);
      e.target.value = !z[2] ? z[1] : '(' + z[1] + ') ' + z[2] + (z[3] ? '-' + z[3] : '');
    }
    else if (e.target.id==='orderUrl' && this.state.menuUrl !== ''){
      e.target.value = '';
    }
    else if (e.target.id==='menuUrl' && this.state.orderUrl !== ''){
      e.target.value = '';
    }

    // if target id includes string 'day'
    // regex for time format with grayed out autofill
    else if (e.target.id.includes('day')){
      console.log('change')
      var x = e.target.value.replace(/\D/g, '');
      var y = '';
      if (x.length === 1){
        y = (x[0]+':00')
      }
      else if (x.length === 2){
        if (x[0] === 0){
          y = (x[1]+':00')  
        }
        else if (x[0] === 1 && (x[1] === 0 || x[1] === 1 || x[1] === 2)){
          y = (x[0]+x[1]+':00') 
        }
        else { 
          y = (x[0]+':'+x[1]+'0')
        }
      }
      else if (x.length === 3){
        if (x[0] === 0){
          y = (x[1]+':'+x[2]+'0')  
        }
        else if (x[0] === 1 && (x[1] === 0 || x[1] === 1 || x[1] === 2)){
          y = (x[0]+x[1]+':'+x[2]+'0') 
        }
        else {
          y = (x[0]+':'+x[1]+x[2])
        }
      }
      else{
        if (x[0] === 0){
          y = (x[1]+':'+x[2]+x[3])
        }
        else{
          y = (x[0]+x[1]+':'+x[2]+x[3])
        }
      }  
      console.log(y)


    }


    this.setState({
      [e.target.id]: e.target.value
    });  
  }

  preventSubmit = (e) =>{
    e.preventDefault();
  }

  handleSubmit = () => {
    // e.preventDefault();
    //if from pending then update pending, if from pendingCreate add to pending and delete from pendingCreate
    // if restaurant.id is in 'restaurants' as an id then it is from pending, 
    var fields = {...this.state};
    for (var key in fields) {
      if (this.state.hasOwnProperty(key) && this.state[key.toString()]===undefined) {
        console.log('testing undefined');
        this.setState({ [key.toString()]: "" });
      }
    }

    //can i just spread the state in editRestaurantAdmin functions???
    if(this.state.fromPending){
    this.setState({
    hours:[
    this.state.sundayAM + ' ' + this.state.sunAM + ' - ' + this.state.sundayPM + ' ' + this.state.sunPM, 
    this.state.mondayAM + ' ' + this.state.monAM + ' - ' + this.state.mondayPM + ' ' + this.state.monPM,
    this.state.tuesdayAM + ' ' + this.state.tueAM + ' - ' + this.state.tuesdayPM + ' ' + this.state.tuePM,
    this.state.wednesdayAM + ' ' + this.state.wedAM + ' - ' + this.state.wednesdayPM + ' ' + this.state.wedPM,
    this.state.thursdayAM + ' ' + this.state.thuAM + ' - ' + this.state.thursdayPM + ' ' + this.state.thuPM,
    this.state.fridayAM + ' ' + this.state.friAM + ' - ' + this.state.fridayPM + ' ' + this.state.friPM,
    this.state.saturdayAM + ' ' + this.state.satAM + ' - ' + this.state.saturdayPM + ' ' + this.state.satPM
    ],
    editorId: this.props.auth.uid,
    editedAt: new Date()
    },()=>this.props.pendingEditRestaurant(
    {
    name: this.state.name,
    url: this.state.url,
    phoneNumber: this.state.phoneNumber,
    orderUrl: this.state.orderUrl,
    menuUrl: this.state.menuUrl,
    address: this.state.address,
    hours: this.state.hours,
    content: this.state.content,
    tags: this.state.tags,
    authorId: this.state.authorId,
    createdAt: this.state.createdAt,
    editorId: this.state.editorId,
    editedAt: this.state.editedAt,
    restaurantId: this.state.restaurantId,

    sunAM: this.state.sunAM,
    sunPM: this.state.sunPM,
    sundayAM: this.state.sundayAM,
    sundayPM: this.state.sundayPM,
    
    monAM: this.state.monAM,
    monPM: this.state.monPM,
    mondayAM: this.state.mondayAM,
    mondayPM: this.state.mondayPM,

    tueAM: this.state.tueAM,
    tuePM: this.state.tuePM,
    tuesdayAM: this.state.tuesdayAM,
    tuesdayPM: this.state.tuesdayPM,

    wedAM: this.state.wedAM,
    wedPM: this.state.wedPM,
    wednesdayAM: this.state.wednesdayAM,
    wednesdayPM: this.state.wednesdayPM,

    thuAM: this.state.thuAM,
    thuPM: this.state.thuPM,
    thursdayAM: this.state.thursdayAM,
    thursdayPM: this.state.thursdayPM,

    friAM: this.state.friAM,
    friPM: this.state.friPM,
    fridayAM: this.state.fridayAM,
    fridayPM: this.state.fridayPM,

    satAM: this.state.satAM,
    satPM: this.state.satPM,
    saturdayAM: this.state.saturdayAM,
    saturdayPM: this.state.saturdayPM
    }, this.props.match.params.id, ()=>{this.props.history.push('/')}));  
    }else{
    this.setState({
    hours:[
    this.state.sundayAM + ' ' + this.state.sunAM + ' - ' + this.state.sundayPM + ' ' + this.state.sunPM, 
    this.state.mondayAM + ' ' + this.state.monAM + ' - ' + this.state.mondayPM + ' ' + this.state.monPM,
    this.state.tuesdayAM + ' ' + this.state.tueAM + ' - ' + this.state.tuesdayPM + ' ' + this.state.tuePM,
    this.state.wednesdayAM + ' ' + this.state.wedAM + ' - ' + this.state.wednesdayPM + ' ' + this.state.wedPM,
    this.state.thursdayAM + ' ' + this.state.thuAM + ' - ' + this.state.thursdayPM + ' ' + this.state.thuPM,
    this.state.fridayAM + ' ' + this.state.friAM + ' - ' + this.state.fridayPM + ' ' + this.state.friPM,
    this.state.saturdayAM + ' ' + this.state.satAM + ' - ' + this.state.saturdayPM + ' ' + this.state.satPM
    ],
    editorId: this.props.auth.uid,
    editedAt: new Date()
    },()=>this.props.editCreateRestaurant(
    {
    name: this.state.name,
    url: this.state.url,
    phoneNumber: this.state.phoneNumber,
    orderUrl: this.state.orderUrl,
    menuUrl: this.state.menuUrl,
    address: this.state.address,
    hours: this.state.hours,
    content: this.state.content,
    tags: this.state.tags,
    authorId: this.state.authorId,
    createdAt: this.state.createdAt,
    editorId: this.state.editorId,
    editedAt: this.state.editedAt,
    restaurantId: this.state.restaurantId,

    sunAM: this.state.sunAM,
    sunPM: this.state.sunPM,
    sundayAM: this.state.sundayAM,
    sundayPM: this.state.sundayPM,
    
    monAM: this.state.monAM,
    monPM: this.state.monPM,
    mondayAM: this.state.mondayAM,
    mondayPM: this.state.mondayPM,

    tueAM: this.state.tueAM,
    tuePM: this.state.tuePM,
    tuesdayAM: this.state.tuesdayAM,
    tuesdayPM: this.state.tuesdayPM,

    wedAM: this.state.wedAM,
    wedPM: this.state.wedPM,
    wednesdayAM: this.state.wednesdayAM,
    wednesdayPM: this.state.wednesdayPM,

    thuAM: this.state.thuAM,
    thuPM: this.state.thuPM,
    thursdayAM: this.state.thursdayAM,
    thursdayPM: this.state.thursdayPM,

    friAM: this.state.friAM,
    friPM: this.state.friPM,
    fridayAM: this.state.fridayAM,
    fridayPM: this.state.fridayPM,

    satAM: this.state.satAM,
    satPM: this.state.satPM,
    saturdayAM: this.state.saturdayAM,
    saturdayPM: this.state.saturdayPM
    }, this.props.match.params.id, ()=>{this.props.history.push('/')}));
    }
    
  }

  submitInterruptor =(e)=>{document.getElementById("myModal").style.display = "block";}
  closeFunction =(e)=>{document.getElementById("myModal").style.display = "none";}


  render() {
    const { auth, restaurants } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />
    

    if(restaurants){
      var tagsList = tagFunctions.compileTags(restaurants);
      var options = tagsList;
    }

    if(this.state.tags){
      var startOptions = this.state.tags;
      startOptions = options.filter(option => (startOptions.includes(option['value'])) )
    }

    if(this.state.sundayAM){
      console.log(this.state.sundayAM)
    }

    return (
      <div className="container">
        
        <div id="myModal" className="modal2">
          <div className="modal-content2">
            <span className="close2" onClick={this.closeFunction}>&times;</span>
            <p>Are you sure you want to submit?</p>
            <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
              <button className="btn pink lighten-1" onClick={this.handleSubmit}>Submit</button>
            </div>
          </div>
        </div>

        <form className="form" autoComplete="off" onSubmit={this.preventSubmit}>
          <h5 className="white-text">Edit a Restaurant</h5>
          <div className="input-field">
            <input type="text" id='name' name='name' value={this.state.name} autoComplete="new-password" onChange={this.handleChange} />
            <label className='active' htmlFor="title">Restaurant Name</label>
          </div>
          <div className="input-field">
            <textarea id="content" className="materialize-textarea" value={this.state.content} onChange={this.handleChange}></textarea>
            <label className='active' htmlFor="content">Content</label>
          </div>
          <div className="input-field">
            <input type="text" id='address' value={this.state.address} name='address' onChange={this.handleChange} />
            <label className='active' htmlFor="title">Address</label>
          </div>
          <div className="input-field">
            <input type="text" id='phoneNumber' value={this.state.phoneNumber} onFocus={this.onFocus} onChange={this.handleChange} />
            <label className='active' htmlFor="title">Phone Number</label>
          </div>
          <div className="input-field">
            <input type="text" id='url' value={this.state.url} onChange={this.handleChange} />
            <label className='active' htmlFor="title">Link to Website</label>
          </div>
          <div className="input-field">
            <input type="text" id='orderUrl' value={this.state.orderUrl} onChange={this.handleChange} />
            <label className='active' htmlFor="title">Link to Order Online</label>
          </div>
          <div className="input-field">
            <input type="text" id='menuUrl' value={this.state.menuUrl} onChange={this.handleChange} />
            <label className='active' htmlFor="title">Link to Menu</label>
          </div>
          <Creatable isMulti options={options} value={startOptions} onChange={this.handleSelect}/>
          <div className="input-field">
            <span style={{color: "white"}}> Hours </span>
          </div>
          <div>
            <label className='input-row'>
            Sunday
              <input style={{width:'60px'}} type="text" id='sundayAM' value={this.state.sundayAM} onChange={this.handleChange} onBlur={this.onBlur} />
            </label>
            <label className='input-row'>
              <select id='sunAM' style={{width:'60px'}} className='browser-default' value={this.state.sunAM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
            <label className='input-row'>
              <input style={{width:'60px'}} type="text" id='sundayPM' value={this.state.sundayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='sunPM' style={{width:'60px'}} className='browser-default' value={this.state.sunPM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
          </div>
          
          <div>
            <label className='input-row'>
            Monday
              <input style={{width:'60px'}} type="text" id='mondayAM' value={this.state.mondayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='monAM' style={{width:'60px'}} className='browser-default' value={this.state.monAM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
            <label className='input-row'>
              <input style={{width:'60px'}} type="text" id='mondayPM' value={this.state.mondayPM} onChange={this.handleChange} onBlur={this.onBlur} />
            </label>
            <label className='input-row'>
              <select id='monPM' style={{width:'60px'}} className='browser-default' value={this.state.monPM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
          </div>

          <div>
            <label className='input-row'>
            Tuesday
              <input style={{width:'60px'}} type="text" id='tuesdayAM' value={this.state.tuesdayAM} onChange={this.handleChange} onBlur={this.onBlur} />
            </label>
            <label className='input-row'>
              <select id='tueAM' style={{width:'60px'}} className='browser-default' value={this.state.tueAM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
            <label className='input-row'>
              <input style={{width:'60px'}} type="text" id='tuesdayPM' value={this.state.tuesdayPM} onChange={this.handleChange} onBlur={this.onBlur} />
            </label>
            <label className='input-row'>
              <select id='tuePM' style={{width:'60px'}} className='browser-default' value={this.state.tuePM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
          </div>

          <div>
            <label className='input-row'>
            Wednesday
              <input style={{width:'60px'}} type="text" id='wednesdayAM' value={this.state.wednesdayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='wedAM' style={{width:'60px'}} className='browser-default' value={this.state.wedAM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
            <label className='input-row'>
              <input style={{width:'60px'}} type="text" id='wednesdayPM' value={this.state.wednesdayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='wedPM' style={{width:'60px'}} className='browser-default' value={this.state.wedPM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
          </div>

          <div>
            <label className='input-row'>
            Thursday
              <input style={{width:'60px'}} type="text" id='thursdayAM' value={this.state.thursdayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='thuAM' style={{width:'60px'}} className='browser-default' value={this.state.thuAM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
            <label className='input-row'>
              <input style={{width:'60px'}} type="text" id='thursdayPM' value={this.state.thursdayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='thuPM' style={{width:'60px'}} className='browser-default' value={this.state.thuPM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
          </div>

          <div>
            <label className='input-row'>
            Friday
              <input style={{width:'60px'}} type="text" id='fridayAM' value={this.state.fridayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='friAM' style={{width:'60px'}} className='browser-default' value={this.state.friAM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
            <label className='input-row'>
              <input style={{width:'60px'}} type="text" id='fridayPM' value={this.state.fridayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='friPM' style={{width:'60px'}} className='browser-default' value={this.state.friPM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
          </div>

          <div>
            <label className='input-row'>
            Saturday
              <input style={{width:'60px'}} type="text" id='saturdayAM' value={this.state.saturdayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='satAM' style={{width:'60px'}} className='browser-default' value={this.state.satAM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
            <label className='input-row'>
              <input style={{width:'60px'}} type="text" id='saturdayPM' value={this.state.saturdayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
            </label>
            <label className='input-row'>
              <select id='satPM' style={{width:'60px'}} className='browser-default' value={this.state.satPM} onChange={this.handleChange}>
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </label>
          </div>
          
          <div className="input-field">
            <button className="btn pink lighten-1" onClick={this.submitInterruptor}>Edit</button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    restaurants: state.firestore.ordered.restaurants
  }
}

const mapDispatchToProps = dispatch => {
  return {
    editRestaurant: (project, id, callback) => dispatch(editRestaurant(project, id, callback)),
    editCreateRestaurant: (project, id, callback) => dispatch(editCreateRestaurant(project, id, callback)),
    pendingEditRestaurant: (project, id, callback) => dispatch(pendingEditRestaurant(project, id, callback))
  }
}


const mapTags = (tags) =>{
  return(tags['value'])
}

export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  firestoreConnect(props =>{
    const userId = props.auth.uid
    if(!userId){
      return []
    }
    return[
    { collection: 'restaurants' }
  ]})
)(AdminEditRestaurant)
